import React, {Component} from 'react';
import HomeHeader from "../components/Home/HomeHeader";
import Section1Home from "../components/Home/Section1Home";
import Affiliations from "../components/Home/Affiliations";
import ContactForm from "../components/Home/ContactForm";
import OurStory from "../components/Home/OurStory";

import hngutils from "../assets/libs/hngutils";

class IndexPage extends Component {
    constructor (props) {
      super(props);

      this.props.data.allWordpressPage.edges.forEach(edge => {
        hngutils.imageSrcToLocalFile(edge.node.acf.image);
        hngutils.imageSrcToLocalFile(edge.node.acf.image_one);
        hngutils.imageSrcToLocalFile(edge.node.acf.image_two);
      });       

      this.props.data.allWordpressPost.edges.forEach(edge => {
        hngutils.imageSrcToLocalFile(edge.node.acf.logo);
      });
    }

    render() {
        const {allWordpressPage, allWordpressPost} = this.props.data;

        const pageData = allWordpressPage.edges.map(i => {
            const {menu_order, acf: {header, subheader, paragraph, image, image_one, image_two}} = i.node;
            return (
              {menu_order, header, subheader, paragraph, image, image_one, image_two}
            )
        }).sort((a, b) => a.menu_order - b.menu_order);
        
        const postData = allWordpressPost.edges;
        
        return (
          <div>
              <HomeHeader data={pageData[0]}/>
              <Section1Home data={pageData[1]}/>
              <OurStory data={pageData[2]}/>
              <Affiliations data={pageData[3]} affiliateData={postData}/>
							{/*<ContactForm data={pageData[4]}/> */}
          </div>
        )
    }
}

export default IndexPage

// wordpress parent for home = 9

export const pageQuery = graphql`
    query homePageQuery {
        allWordpressPage(filter: {wordpress_parent:{eq:9}}){
            edges {
                node {
                    title
                    menu_order
                    acf{
                        header
                        subheader
                        paragraph
                        image{
                            source_url
                            alt_text
                            description
                            title
                            caption
                            localFile {
                              childImageSharp {
                                original {
                                  src
                                }
                              }
                            }
                        }
                        image_one {
                            title
                            caption
                            description
                            source_url
                            alt_text
                            localFile {
                              childImageSharp {
                                original {
                                  src
                                }
                              }
                            }                            
                        }
                        image_two {
                            title
                            caption
                            description
                            source_url
                            alt_text
                            localFile {
                              childImageSharp {
                                original {
                                  src
                                }
                              }
                            }                            
                        }
                    }
                }
            }
        }
        allWordpressPost(filter:{acf:{type:{eq:"affiliate"}}}) {
            edges {
                node {
                    acf {
                        name
                        link
                        logo {
                            source_url
                            alt_text
                            localFile {
                              childImageSharp {
                                original {
                                  src
                                }
                              }
                            }
                        }
                    }
                }
            }
        }
    }`;



// WEBPACK FOOTER //
// ./src/pages/index.js